import {SchemasOrderSubscription} from '@shared/schemas/order'

import getApi from '@web/helpers/api'

const api = getApi('/orderApi')

const API_BASE_URL = '/orderSheet/subscription/subscription'

export const fetchSubscription = async (params: SchemasOrderSubscription['/subscription/info']['request']) => {
    const {
        data: {result},
    } = await api.get<{result: SchemasOrderSubscription['/subscription/info']['response']}>(`${API_BASE_URL}/info`, {
        params,
    })

    return result
}
